// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Liff from "../liff/Liff.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Layout from "../Layout.bs.js";
import * as HookProfile from "../hooks/HookProfile.bs.js";
import * as ProfileContext from "./ProfileContext.bs.js";
import * as ProfileReducer from "./ProfileReducer.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

function ProfileRoutes(Props) {
  var liff = React.useContext(Liff.context);
  var token = liff.access_token;
  var state = HookProfile.useProfile(token);
  var match = React.useContext(ProfileContext.context);
  var reducer = match.reducer;
  React.useEffect((function () {
          if (typeof state === "number") {
            switch (state) {
              case /* UserNotFound */1 :
                  RescriptReactRouter.push("/register");
                  break;
              case /* Request */0 :
              case /* Failure */2 :
                  break;
              
            }
          } else if (state.TAG === /* SuccessPreRegisterdProfile */0) {
            var profile = ProfileReducer.fromPreProfile(state._0);
            Curry._1(reducer.dispatch, {
                  TAG: /* ChangeState */0,
                  _0: profile
                });
            RescriptReactRouter.push("/register");
          } else {
            RescriptReactRouter.push("/member");
          }
          
        }), [state]);
  return React.createElement(Layout.Loading.make, {});
}

var make = ProfileRoutes;

export {
  make ,
  
}
/* Liff Not a pure module */
